module.exports = __webpack_public_path__ + "img/packages/6.98cbe7.png";